// Environment configuration with type safety
export const config = {
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || 'https://api.nduka.io/api/v2',
    timeout: 30000,
  },
  features: {
    debug: import.meta.env.VITE_ENABLE_DEBUG === 'true',
    analytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
  },
  auth: {
    tokenKey: 'auth-token',
    csrfTokenKey: 'csrf-token',
    userKey: 'user',
  },
  app: {
    name: 'Career Assistant',
    version: '5.0.0',
  },
} as const;

// Validate required environment variables
if (!import.meta.env.VITE_API_BASE_URL && import.meta.env.PROD) {
  console.warn('VITE_API_BASE_URL is not set, using default value');
}